import { LocalDate } from '@js-joda/core';

import { Patient } from '@dreryk/egabinet-patient-frontend-api';
import { IdentityDocument } from '@dreryk/egabinet-patient-published-language-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { passportIdentityDocument } from '../../../../../../../../translations';

import { PassportIdentityDocumentEditForm } from './PassportIdentityDocumentEditForm';
import { PassportIdentityDocumentEditModalConfirmButton } from './PassportIdentityDocumentEditModalConfirmButton';

const isIdentityDocumentNotValid = (identityDocument: IdentityDocument): boolean => {
   const today = LocalDate.now();
   return identityDocument.getValidTo()?.isBefore(today) ?? false;
};

type PassportIdentityDocumentEditModalProps = {
   readonly patientId: number;
   readonly identityDocument: IdentityDocument;
   readonly onCancel: VoidFunction;
   readonly onSuccess: VoidFunction;
   readonly onIdentityDocumentUpdated: (patient: Patient) => Promise<void> | void;
};

export const PassportIdentityDocumentEditModal = (props: PassportIdentityDocumentEditModalProps): JSX.Element => {
   const title = isIdentityDocumentNotValid(props.identityDocument)
      ? passportIdentityDocument.edit.modal.documentNotValidTitle
      : passportIdentityDocument.edit.modal.basicTitle;
   return (
      <Modal testId={'passportIdentityDocumentEdit'} title={title} width={ModalWidth.WIDE}>
         <PassportIdentityDocumentEditForm identityDocument={props.identityDocument}>
            {({ handleSubmit, formState }) => (
               <>
                  <PassportIdentityDocumentEditModalConfirmButton
                     patientId={props.patientId}
                     handleSubmit={handleSubmit}
                     onIdentityDocumentUpdated={props.onIdentityDocumentUpdated}
                     onSuccess={props.onSuccess}
                  />
                  <ModalCancelButton
                     label={commonTranslationKeys.cancel}
                     onClick={props.onCancel}
                     shouldConfirmExit={formState.isDirty}
                  />
                  <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={formState.isDirty} />
               </>
            )}
         </PassportIdentityDocumentEditForm>
      </Modal>
   );
};
